document.addEventListener('DOMContentLoaded', () => {

    var nmInner = document.querySelector('.nm-inner');

    nmInner.querySelectorAll('.nm-menu-el.with-sub .nm-menu-el-inner').forEach((el) => {
        el.addEventListener('click', () => {
            from1To2(el);
        });
    });

    nmInner.querySelectorAll('.nm-menu-sub-back').forEach((el) => {
        el.addEventListener('click', () => {
            from2To1(el);
        })
    });

    nmInner.querySelectorAll('.nm-menu-subel.with-subsub .nm-menu-subel-inner').forEach((el) => {
        el.addEventListener('click', () => {
            from2To3(el);
        })
    });

    nmInner.querySelectorAll('.nm-menu-subsub-back').forEach((el) => {
        el.addEventListener('click', () => {
            from3To2(el);
        })
    });

}, { passive: true });

function from1To2 (el) {
    const nmInner = document.querySelector('.nm-inner');
    nmInner.classList.remove('lvl1', 'lvl2', 'lvl3');
    nmInner.classList.add('lvl2');
    setActive(el.closest('.nm-menu-el').querySelector('.nm-menu-sub'));
}

function from2To1 (el) {
    const nmInner = document.querySelector('.nm-inner');
    nmInner.classList.remove('lvl1', 'lvl2', 'lvl3');
    nmInner.classList.add('lvl1');
    unsetActive(el.closest('.nm-menu-sub'));
}

function from2To3 (el) {
    const nmInner = document.querySelector('.nm-inner');
    nmInner.classList.remove('lvl1', 'lvl2', 'lvl3');
    nmInner.classList.add('lvl3');
    setActive(el.closest('.nm-menu-subel').querySelector('.nm-menu-subsub'));
}

function from3To2 (el) {
    const nmInner = document.querySelector('.nm-inner');
    nmInner.classList.remove('lvl1', 'lvl2', 'lvl3');
    nmInner.classList.add('lvl2');
    unsetActive(el.closest('.nm-menu-subsub'));
}